/* === Unterkante der Kopfleiste als CSS-Variable ===
   Schreibt laufend die Unterkante des Headers als --dgl-header-bottom an das
   <html>-Element. Alles, was direkt darunter beginnen soll, kann sich darauf beziehen —
   auf dem Handy zurzeit die Suchebene (assets/mobile.css).

   Warum nicht Dawns --header-bottom-position? Die setzt Shopify AUSSCHLIESSLICH beim
   Oeffnen des Hamburger-Menues (global.js, HeaderDrawer.openMenuDrawer) und danach nur
   noch bei resize. Wer es nie geoeffnet hat, hat gar keinen Wert; wer es einmal
   geoeffnet hat, einen von damals. Genau daran ist die Verankerung des Kategoriemenues
   schon einmal gescheitert.

   Nachgefuehrt wird beim Scrollen, weil die Kopfleiste ihre Hoehe aendert: Ab 20px
   Scrollstrecke klappt der Untertitel ein (base.css, .header-compact).

   Die Messung selbst ist billig (ein getBoundingClientRect pro Bild) und laeuft ueber
   requestAnimationFrame, es wird also hoechstens einmal je Bildaufbau gerechnet. */
(() => {
  const header = document.querySelector('.section-header');
  if (!header) return;

  const root = document.documentElement;
  let ticking = false;

  const measure = () => {
    ticking = false;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    root.style.setProperty('--dgl-header-bottom', bottom + 'px');
  };

  const schedule = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(measure);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  // Der Untertitel klappt mit einem Uebergang ein — waehrenddessen aendert sich die
  // Hoehe laufend. Am Ende noch einmal messen, sonst bleibt der letzte Zwischenwert.
  header.addEventListener('transitionend', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  /* ── Hoehe des tatsaechlich sichtbaren Bereichs ────────────────────────────
     Gebraucht von der Suchebene: Ihre Karte scrollt in sich selbst. Ist die Karte so
     hoch wie der ganze Bildschirm, liegt ihr unteres Ende hinter der Tastatur — die
     letzten Vorschlaege sind dann nicht erreichbar, und am Ende der Liste laeuft die
     Wischgeste in die Seite dahinter weiter.
     Mit der sichtbaren Hoehe endet die Karte dort, wo auch der Blick endet.

     WICHTIG: nur auf resize horchen, NICHT auf scroll. Beim Scrollen meldet iOS
     laufend winzige Verschiebungen; wer darauf reagiert und die Ebene nachfuehrt,
     aendert damit wieder den Ausschnitt — eine Rueckkopplung, die das Bild sichtbar
     zittern laesst. Die Tastatur loest ein resize aus, das genuegt.

     Die Flaeche, die dadurch unter der Karte frei wird, deckt die ueberdimensionierte
     Huelle ab (assets/mobile.css) — in derselben Farbe, also unsichtbar. */
  const vv = window.visualViewport;
  if (!vv) return;

  const measureViewport = () => {
    root.style.setProperty('--dgl-vv-height', Math.round(vv.height) + 'px');
  };

  vv.addEventListener('resize', measureViewport);
  window.addEventListener('orientationchange', measureViewport);
  measureViewport();
})();
